import React from "react";
import {
  Stack,
  Typography,
  Card,
  Tooltip,
  Icon,
  IconButton,
  Alert,
} from "investira.react.components";
import { formats, validators } from "investira.sdk";

const Highlights = (props) => {
  const { data } = props;
  return (
    <>
      <Stack
        direction="column"
        sx={{ gap: 1 }}
        component="section"
        flexGrow={1}
      >
        <Stack gap={1} flexGrow={1} direction={{ xs: "column", md: "row" }}>
          <Card
            sx={{
              flexGrow: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Total Financeiro
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{formats.formatNumber(2713049.56, 2, true, true)}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Cota
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{formats.formatNumber(1, 4, true, false)}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Confiança
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{formats.formatNumber(95, 0, true)}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Sharpe
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{formats.formatNumber(0.3208, 4, true)}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Peso EWMA
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{formats.formatNumber(94, 0, true)}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Amostragem
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>252 dias</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Dias EWMA
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>60</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card
            sx={{
              flex: 1,
              display: "flex",
              minHeight: 0,
            }}
          >
            <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
              <Typography
                variant="caption"
                color="textPrimary"
                sx={{ fontWeight: 500 }}
              >
                Taxa de Juros
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>{formats.formatNumber(0, 2, true)}</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </>
  );
};

export default Highlights;
